import axios from "axios";

export default axios.create({
  baseURL: "https://srv940199.hstgr.cloud/api",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
